import { Col, Container, Row } from "reactstrap";
import UsersWidget from "./components/users-widget";
import MachinesWidget from "./components/machines-widget/index";
import DevicesMap from "./components/devices-map";
import { useDashboard } from "../../common/hooks/api/dashboard";
import { toastError } from "../../helpers/toast-helper";
import { getResponseItemData } from "../../helpers/response-helper";

const DashboardPage = () => {
    const { data: dashboardResponse, isLoading } = useDashboard({
        onError: () => {
            toastError("Cannot fetch dashboard data");
        },
    });

    const { data } = getResponseItemData(dashboardResponse);

    return (
        <Container fluid>
            <Row>
                <Col lg={12} xl={6}>
                    <UsersWidget
                        totalCount={data?.allUserCount}
                        recentUsers={data?.recentUsers}
                        isLoading={isLoading}
                    />
                </Col>
                <Col lg={12} xl={6}>
                    <MachinesWidget
                        totalCount={data?.allDeviceCount}
                        recentMachines={data?.recentDevices}
                        isLoading={isLoading}
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <DevicesMap />
                </Col>
            </Row>
        </Container>
    );
};

export default DashboardPage;
